import { useState, useEffect } from "react"
import { useParams } from "react-router-dom"
import { Button } from "antd"
import { baseAxiosNoInfo } from "../../../tool/axios"

interface dataType {
    create_time: string // 创建时间
    id: string // 跟进记录id
    follow_man_name: string // 跟进人
    follow_time: string // 跟进时间
    follow_content: string //  跟进内容
    contact_success: number // 是否联系成功，0默认否 1是，整数类型
}

export default function () {

    const param: { id: string } = useParams()
    const [page, setPage] = useState<number>(1)
    const [data, setData] = useState<dataType[]>([])
    const [showLoadBtn, setShowLoadBtn] = useState<boolean>(true)

    useEffect(() => {
        baseAxiosNoInfo('/keeper/check_in/detail/minion_follow_records', {
            params: {
                page,
                check_in_id: param.id
            }

        }).then((res: any) => {
            if (res.records.length > 0) {
                let d = data
                setData([...d, ...res.records])

            } else {
                setShowLoadBtn(false)
            }
        })
    }, [page])

    return <div className="follow-record">
        {/* 管家中心 -> 入住管理 -> 客户详情 -> 管家跟进记录 */}
        {data.length === 0 && '暂无数据'}

        {data.map((el: dataType) => <ul style={{ listStyle: 'none' }}>
            <li>
                <p className="date">跟进日期：{el.follow_time}</p>
            </li>
            <li>
                <p>跟进人：{el.follow_man_name}</p>
            </li>
            <li>
                <p>跟进内容：{el.follow_content}</p>
            </li>
            <li>
                <p>是否联系成功：{el.contact_success === 1 ? '是' : '否'}</p>
            </li>
        </ul>)}

        {showLoadBtn && <Button onClick={() => {
            setPage(page + 1)
        }}>加载更多数据</Button>}
    </div>
}